import React from 'react';
import PropTypes from 'prop-types';

const checkMarkTrue = ({ className }) => {
    return (
        <svg
            width="16"
            height="11"
            viewBox="0 0 16 11"
            fill="none"
            className={`fill-current ${className}`}
            xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.1088 0.558058C15.3528 0.802136 15.3528 1.19786 15.1088 1.44194L5.9421 10.6086C5.69803 10.8527 5.3023 10.8527 5.05822 10.6086L0.891554 6.44194C0.647477 6.19786 0.647477 5.80214 0.891554 5.55806C1.13563 5.31398 1.53136 5.31398 1.77544 5.55806L5.50016 9.28278L14.2249 0.558058C14.469 0.313981 14.8647 0.313981 15.1088 0.558058Z" fill="currentColor"/>
        </svg>
    );
};

checkMarkTrue.propTypes = {
    className: PropTypes.string,
};

checkMarkTrue.defaultProps = {
    className: '',
};

export default checkMarkTrue;
